export const BUILD_CAMPAIGN_PAGE_TABLE_ID = "BUILD_CAMPAIGN_PAGE_TABLE";
